export type ActionFlags = {
  accept: boolean;
  reject: boolean;
  skip: boolean;
  reprocess: boolean;
};

const NONE: ActionFlags = {
  accept: false,
  reject: false,
  skip: false,
  reprocess: false,
};

/** Per-status write actions for overlay and cards (R27). */
export function getAvailableActions(verificationStatus: string | null | undefined): ActionFlags {
  switch (verificationStatus) {
    case "pending_review":
      return { accept: true, reject: true, skip: true, reprocess: true };
    case "skipped":
      return { accept: true, reject: true, skip: false, reprocess: true };
    case "rejected":
      // Accept → Accepted; Skip → Skip tab (never back to pending_review); Reprocess regenerates.
      return { accept: true, reject: false, skip: true, reprocess: true };
    case "accepted":
      // Skip → Skip tab (never back to pending_review); Reject → Rejected.
      return { accept: false, reject: true, skip: true, reprocess: false };
    default:
      return { ...NONE };
  }
}

/** Intersection of actions valid for every selected status (AE12). */
export function getSharedActions(statuses: Array<string | null | undefined>): ActionFlags {
  if (!statuses.length) return { ...NONE };
  return statuses.reduce<ActionFlags>((acc, status) => {
    const next = getAvailableActions(status);
    return {
      accept: acc.accept && next.accept,
      reject: acc.reject && next.reject,
      skip: acc.skip && next.skip,
      reprocess: acc.reprocess && next.reprocess,
    };
  }, getAvailableActions(statuses[0]));
}

/** Skip from Accepted/Rejected moves the asset to Skip — never back to pending Review. */
export function skipActionLabel(verificationStatus: string | null | undefined): string {
  if (verificationStatus === "accepted" || verificationStatus === "rejected") {
    return "To Skip";
  }
  return "Skip";
}
